var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSaveIcon = function SvgSaveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1.33337C7.74845 1.33432 5.81889 2.94312 5.41309 5.15771C7.35104 4.09722 9.78175 4.80855 10.8422 6.74649C11.497 7.94291 11.497 9.39045 10.8422 10.5869C13.3764 10.1226 15.0545 7.69194 14.5903 5.15775C14.1843 2.94178 12.2528 1.33252 9.99992 1.33337Z",
    fill: "#D5D5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 14.6667C6.50729 14.6667 7.99967 13.1743 7.99967 11.3333C7.99967 9.49238 6.50729 8 4.66634 8C2.82539 8 1.33301 9.49238 1.33301 11.3333C1.33301 13.1743 2.82539 14.6667 4.66634 14.6667Z",
    fill: "#6563FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33351 4.66663C5.27792 4.66683 3.55711 6.22502 3.35352 8.27051C5.04405 7.54418 7.00331 8.32582 7.72963 10.0164C8.09039 10.856 8.09039 11.807 7.72963 12.6466C9.92783 12.4281 11.5326 10.4689 11.3141 8.27068C11.1106 6.22486 9.38942 4.66644 7.33351 4.66663Z",
    fill: "#A1A1ED"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saveIcon.9dd38b2e.svg";
export { ForwardRef as ReactComponent };